import React from "react";
import { resultData } from "./data";
import SectionBgImg from "./components/SectionBgImg";
import config from "../../config";

function isRTL() {
  if (typeof document !== "undefined") {
    const dir =
      document.body?.dir ||
      document.documentElement?.dir ||
      document.documentElement?.getAttribute("dir");
    return dir === "rtl";
  }
  return false;
}

const TopCard = ({ data, images }) => {
  const rtl = isRTL();
  return (
    <div className="relative">
      <SectionBgImg />
      <SectionBgImg className="top-1/2" />
      <div className="relative m-16 md-max:my-8 md-max:mx-4">
        <img
          src="/top-card-bg.webp"
          alt="top-card"
          className="w-full h-full object-cover md-max:h-[180px] rounded-xl"
        />
        <div
          className={
            `absolute top-8 md-max:top-2 flex flex-col gap-4 text-white ` +
            (rtl
              ? "right-8 md-max:right-2 w-full"
              : "left-8 md-max:left-2")
          }
        >
          <p className="text-7xl font-semibold sm-max:text-lg sm:md-max:leading-[2.5rem] sm:md-max:!text-[35px] sm-max:leading-5 max-w-[60%]">
            {data?.name || "name goes here"}
          </p>
          {/* <p className="text-2xl font-semibold">ENFP-A</p> */}
        </div>
        <div
          className={
            `absolute bottom-8 md-max:bottom-2 flex flex-col gap-4 text-white max-w-[60%] sm-max:max-w-[60%] ` +
            (rtl
              ? "right-8 md-max:right-2 items-end text-right"
              : "left-8 md-max:left-2")
          }
        >
          <p className="text-xl sm-max:text-[10px] sm-max:leading-[14px] font-normal sm:md-max:text-[13px] sm:md-max:leading-[16px]">
            {data?.simple_desc || "simple description goes here"}
          </p>
          {/* <div className="flex gap-2 font-bold text-xl">
            {resultData.tags.map((item, index) => (
              <React.Fragment key={index}>
                <p key={index}>{item}</p>
                <span>
                  {index !== resultData.tags.length - 1 && (
                    <span className="text-white">|</span>
                  )}
                </span>
              </React.Fragment>
            ))}
          </div> */}
        </div>
        <div
          className={
            `absolute bottom-8 md-max:bottom-2.5 ` +
            (rtl ? "left-8 md-max:left-2" : "right-8 md-max:right-2")
          }
        >
          <img
            src={images?.split(',')[0] ? images.split(',')[0] : "/top-card-char.webp"}
            alt="character"
            className={
              "object-cover h-[300px] md-max:max-h-[150px] transition-transform duration-200" +
              (rtl ? " scale-x-[-1]" : "")
            }
            style={rtl ? { transform: "scaleX(-1)" } : undefined}
          />
        </div>
      </div>
    </div>
  );
};

export default TopCard;
